/* eslint-disable sort-keys */
import {
	messageTemplateConstants
}from './constants'
import {
	defAction
}from '../../../helpers/defaultAction'
import api from './api'
import downloadFile from '../../../helpers/downloadFile'

export const messageTemplateActions = {
	getList,
	create,
	_delete,
	getSample,
	addSample,
	downloadSampleExample,
	downloadSample,
	getDocumentScalesClear,
	getDocumentScales,
	documentScalesClear,
	getDocumentScaleClear
}

function _delete(values){
	const dispatchObj = {
		constants : messageTemplateConstants.Delete,
		service   : {
			func   : values.reOrgId ? api.deleteLocalMessageTemplate : api.delete,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function create(values){
	const dispatchObj = {
		constants : messageTemplateConstants.Create,
		service   : {
			func   : values.reOrgId ? api.createLocalMessageTemplate : api.create,
			params : values
		}
	}
	return defAction(dispatchObj)
}
function getSample(params){
	const dispatchObj = {
		constants : messageTemplateConstants.GetOrgDocumentScale,
		service   : {
			func   : api.getOrgDocumentScale,
			params : params
		}
	}
	return defAction(dispatchObj)
}
function addSample(params){
	const dispatchObj = {
		constants : messageTemplateConstants.AddOrgDocumentScale,
		service   : {
			func   : api.addOrgDocumentScale,
			params : params
		}
	}
	return defAction(dispatchObj)
}

function getList(values){
	const dispatchObj = {
		constants : messageTemplateConstants.GetMessageTemplates,
		service   : {
			func   : values.reOrgId ? api.getLocalMessageTemplate : api.getMessageTemplates,
			params : values
		}
	}
	return defAction(dispatchObj)
}

function downloadSampleExample(params){
	const dispatchObj = {
		constants : messageTemplateConstants.DownloadDocsScaleExample,
		service   : {
			func   : api.DownloadDocumentScaleExample,
			params : params
		},
		sucFunction: (res) => {
			downloadFile(res, { fileName      : params.Code == 2 ? 'Пример шаблона уведомления заявителю' : 'Пример шаблона сопроводительного письма',
				fileExtension : ".docx" })
		}
	}
	return defAction(dispatchObj)
}
function downloadSample(params, values){
	const dispatchObj = {
		constants : messageTemplateConstants.DownloadDocsScale,
		service   : {
			func   : api.DownloadDocumentScale,
			params : params
		},
		sucFunction: (res) => {
			downloadFile(res, { fileName      : values,
				fileExtension : ".docx" })
		}
	}
	return defAction(dispatchObj)
}
function getDocumentScales(values){
	const dispatchObj = {
		constants : messageTemplateConstants.GetOrgDocumentScales,
		service   : {
			func   : api.GetOrgDocumentScales,
			params : values
		}
	}
	return defAction(dispatchObj)
}
function getDocumentScalesClear(){
	return (dispatch) => dispatch({ type: messageTemplateConstants.GetOrgDocumentScales.CLEAR })
}
function documentScalesClear(){
	return (dispatch) => dispatch({ type: messageTemplateConstants.AddOrgDocumentScale.CLEAR })
}
function getDocumentScaleClear(){
	return (dispatch) => dispatch({ type: messageTemplateConstants.GetOrgDocumentScale.CLEAR })
}